var map = {
	"./FoodWasteQuiz.js": 46,
	"./FoodWasteRadios.js": 47,
	"./FoodWasteResultTabs.js": 48,
	"./FoodWasteSlider.js": 49,
	"./Header.js": 50,
	"./IframeResizer.js": 52,
	"./Ingredients.js": 95,
	"./Quiz.js": 104,
	"./ShareLinks.js": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;


//////////////////
// WEBPACK FOOTER
// ./src/js/components \.js$
// module id = 45
// module chunks = 0